import { ID3Writer } from "browser-id3-writer";
import { parseBlob, selectCover } from "music-metadata";

export const isMp3 = (path) => /\.mp3$/i.test(path);
const text = (x) => (typeof x === "string" ? x : x?.text);
const bufOf = (u8) => u8.buffer.slice(u8.byteOffset, u8.byteOffset + u8.byteLength);

export const writeMp3 = async (fh, t) => {
  const file = await fh.getFile();
  const { common: c } = await parseBlob(file, { duration: false, skipCovers: false });
  const w = new ID3Writer(await file.arrayBuffer());
  if (t.title) w.setFrame("TIT2", t.title);
  if (t.artist) w.setFrame("TPE1", [t.artist]);
  if (t.album) w.setFrame("TALB", t.album);
  if (t.albumartist) w.setFrame("TPE2", t.albumartist);
  if (t.genre) w.setFrame("TCON", [t.genre]);
  if (t.year) w.setFrame("TYER", t.year);
  const of = (n, total) => (total && total >= n ? `${n}/${total}` : String(n));
  if (t.track) w.setFrame("TRCK", of(t.track, c.track?.of));
  if (t.disk) w.setFrame("TPOS", of(t.disk, c.disk?.of));
  const pic = selectCover(c.picture);
  if (pic) { try { w.setFrame("APIC", { type: 3, data: bufOf(pic.data), description: "" }); } catch { /* unknown image type */ } }
  const lyrics = text(c.lyrics?.[0]);
  if (lyrics) w.setFrame("USLT", { description: "", lyrics, language: "eng" });
  const comment = text(c.comment?.[0]);
  if (comment) w.setFrame("COMM", { description: "", text: comment, language: "eng" });
  w.addTag();
  const out = await fh.createWritable();
  await out.write(w.arrayBuffer);
  await out.close();
};
